import { NgModule } from '@angular/core';
import { CommonModule } from '@angular/common';
import { MatIconModule } from '@angular/material/icon';
import { FormsModule, ReactiveFormsModule } from '@angular/forms';
import { NgClickOutsideModule } from 'ng-click-outside2';
import { OverlayModule } from '@angular/cdk/overlay';
import { MatExpansionModule } from '@angular/material/expansion';
import { MatRadioModule } from '@angular/material/radio';
import { NgxSpinnerModule } from 'ngx-spinner';
import { MatStepperModule } from '@angular/material/stepper';
import { MatButtonToggleModule } from '@angular/material/button-toggle';
import { MatMenuModule } from '@angular/material/menu';
import { MatProgressSpinnerModule } from '@angular/material/progress-spinner';
import { TreeSidenavComponent } from './components/tree-sidenav/tree-sidenav.component';
import { TreeSidenavMenuItemComponent } from './components/tree-sidenav/tree-sidenav-menu-item/tree-sidenav-menu-item.component';
import { AdminBaseModule } from '../common/admin-base/admin-base.module';
import { FindUserDetailsComponent } from './components/find-user-details/find-user-details.component';
import { SubnavigationComponent } from './components/subnavigation/subnavigation.component';
import { HeroSlideComponent } from './components/hero-slide/hero-slide.component';
import { PageTitleHeaderComponent } from './components/page-title-header/page-title-header.component';
import { InlineTabsComponent } from './components/inline-tabs/inline-tabs.component';
import { DateAgoPipe } from './pipes/date-ago.pipe';
import { ExpandButtonComponent } from './components/buttons/expand-button/expand-button.component';
import { ConfirmModalComponent } from './components/modals/confirmation-modal/confirm-modal.component';
import { ReplacePipe } from './pipes/replace.pipe';
import { OrdinalSuffixPipe } from './pipes/ordinal-suffix.pipe';
import { ShowTooltipIfTruncatedDirective } from './directives/mat-tooltip-show-if-truncate.directive';
import { MoneyComponent } from './components/money/money.component';
import { PrettyMoneyPipe } from './pipes/pretty-money-formatter.pipe';
import { LimitValueOrUnlimitedPipe } from './pipes/limit-value-or-unlimited.pipe';
import { StartsWithCapitalLetterPipe } from './pipes/starts-with-capital-letter.pipe';
import { DecimalNumberDirective } from './directives/decimal-number.directive';
import { CamelCaseToTextPipe } from './pipes/camel-case-to-text.pipe';
import { CamelCaseToSnakeCasePipe } from './pipes/camel-case-to-snake-case.pipe';
import { MinutesToTimePipe } from './pipes/minutes-to-time.pipe';
import { QuillModule } from 'ngx-quill';
import { DateInFuturePipe } from './pipes/date-in-future.pipe';
import { TimeDurationToAggregatePipe } from './pipes/time-duration-to-aggregate.pipe';
import { ShortNamePipe } from './pipes/short-name.pipe';
import { MatInputModule } from '@angular/material/input';
import { MatFormFieldModule } from '@angular/material/form-field';
import { DynamicTableComponent } from './components/dynamic-table/expand-button/dynamic-table.component';
import { AdminVersionComponent } from './components/admin-version/admin-version.component';

@NgModule({
  declarations: [
    FindUserDetailsComponent,
    TreeSidenavComponent,
    TreeSidenavMenuItemComponent,
    SubnavigationComponent,
    HeroSlideComponent,
    PageTitleHeaderComponent,
    InlineTabsComponent,
    DateAgoPipe,
    ReplacePipe,
    OrdinalSuffixPipe,
    ExpandButtonComponent,
    DynamicTableComponent,
    ConfirmModalComponent,
    ShowTooltipIfTruncatedDirective,
    DecimalNumberDirective,
    MoneyComponent,
    PrettyMoneyPipe,
    LimitValueOrUnlimitedPipe,
    StartsWithCapitalLetterPipe,
    CamelCaseToTextPipe,
    CamelCaseToSnakeCasePipe,
    MinutesToTimePipe,
    MinutesToTimePipe,
    DateInFuturePipe,
    TimeDurationToAggregatePipe,
    ShortNamePipe,
  ],
  exports: [
    FindUserDetailsComponent,
    TreeSidenavComponent,
    SubnavigationComponent,
    PageTitleHeaderComponent,
    InlineTabsComponent,
    DateAgoPipe,
    ReplacePipe,
    OrdinalSuffixPipe,
    DynamicTableComponent,
    ExpandButtonComponent,
    ShowTooltipIfTruncatedDirective,
    DecimalNumberDirective,
    MoneyComponent,
    LimitValueOrUnlimitedPipe,
    PrettyMoneyPipe,
    StartsWithCapitalLetterPipe,
    MinutesToTimePipe,
    CamelCaseToTextPipe,
    CamelCaseToSnakeCasePipe,
    MinutesToTimePipe,
    QuillModule,
    DateInFuturePipe,
    TimeDurationToAggregatePipe,
    ShortNamePipe,
    AdminVersionComponent,
  ],
  imports: [
    CommonModule,
    ReactiveFormsModule,
    FormsModule,
    AdminBaseModule,
    NgClickOutsideModule,
    OverlayModule,
    MatExpansionModule,
    MatRadioModule,
    MatInputModule,
    MatFormFieldModule,
    NgxSpinnerModule,
    MatStepperModule,
    MatButtonToggleModule,
    MatIconModule,
    MatProgressSpinnerModule,
    MatMenuModule,
    AdminVersionComponent,
    QuillModule.forRoot(),
  ],
  providers: [ShortNamePipe],
})
export class SharedModule {}
